<template>
  <div>
    <div class="google-map" ref="googleMap"></div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';

const GOOGLE_MAP_API_KEY = process.env.VUE_APP_API_GOOGLE_KEY;

export default {
  name: 'GoogleMapLoader',
  props: {
    bounds: {
      type: Object,
      default() {
        return {
          isEmpty: true,
          latMax: null,
          latMin: null,
          lonMax: null,
          lonMin: null,
        };
      },
    },
  },
  data() {
    return {
      map: null,
      google: null,
      loader: null,
      options: {
        center: {
          lat: 0,
          lng: 0,
        },
        zoom: 3,
        mapId: 'MAP_ID_LOADER',
      },
      rectangle: null,
      drawingManager: null,
    };
  },
  created() {
    this.loader = new Loader({
      apiKey: GOOGLE_MAP_API_KEY,
      version: 'weekly',
      libraries: ['places', 'marker'],
    });
  },

  mounted() {
    this.initializeMap();
  },

  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;

      // set random  mapId
      this.options.mapId = `MAP_ID_LOADER_${Date.now()}`;

      this.loader
        .load()
        .then((google) => {
          this.google = google;
          this.map = new google.maps.Map(mapContainer, this.options);

          console.log(this.bounds);
          if (this.bounds.isEmpty !== undefined && !this.bounds.isEmpty) {
            this.rectangle = new google.maps.Rectangle({
              map: this.map,
              bounds: {
                north: this.bounds.latMax,
                south: this.bounds.latMin,
                east: this.bounds.lonMax,
                west: this.bounds.lonMin,
              },
            });
          }

          // draw rectangle
          let rectStartLatLng = null;
          google.maps.event.addListener(this.map, 'click', (event) => {
            if (!rectStartLatLng) {
              // start draw
              this.clearBounds();

              rectStartLatLng = event.latLng;

              const initialCoords = [rectStartLatLng, rectStartLatLng, rectStartLatLng, rectStartLatLng];
              this.rectangle = this.map.data.add({
                geometry: new google.maps.Data.Polygon([initialCoords]),
              });
              this.map.data.overrideStyle(this.rectangle, { clickable: false });

              const moveListener = google.maps.event.addListener(this.map, 'mousemove', (moveEvent) => {
                if (!rectStartLatLng || !this.rectangle) return;

                const bounds = new google.maps.LatLngBounds();
                bounds.extend(rectStartLatLng);
                bounds.extend(moveEvent.latLng);

                const sw = bounds.getSouthWest();
                const ne = bounds.getNorthEast();

                const path = [
                  new google.maps.LatLng(ne.lat(), sw.lng()),
                  ne,
                  new google.maps.LatLng(sw.lat(), ne.lng()),
                  sw,
                ];

                this.rectangle.setGeometry(new google.maps.Data.Polygon([path]));
              });

              this.map.set('currentMoveListener', moveListener);
            } else {
              // end draw
              rectStartLatLng = null;

              google.maps.event.removeListener(this.map.get('currentMoveListener'));

              const bounds = new google.maps.LatLngBounds();
              this.rectangle.getGeometry().forEachLatLng((latLng) => {
                bounds.extend(latLng);
              });

              const latLonBounds = bounds.toJSON();

              this.setBounds({
                isEmpty: false,
                latMax: latLonBounds.north,
                latMin: latLonBounds.south,
                lonMax: latLonBounds.east,
                lonMin: latLonBounds.west,
              });
            }
          });
        })
        .catch(() => {
          console.log('Google maps error');
        });
    },

    setBounds({
      isEmpty, latMin, latMax, lonMin, lonMax,
    }) {
      const bounds = {
        isEmpty, latMin, latMax, lonMin, lonMax,
      };
      this.$emit('setBounds', bounds);
    },
    clearBounds() {
      if (this.map && this.rectangle) {
        this.map.data.remove(this.rectangle);
        this.rectangle = null;
        this.setBounds({
          isEmpty: true, latMin: null, latMax: null, lonMin: null, lonMax: null,
        });
      }
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  min-height: 400px;
  height: 500px;
}
</style>
